/* eslint-disable */
import React, { useState, useEffect } from "react";

import VirtualGridComponent from "../react/components_proto/VirtualGridComponent/VirtualGridComponent";
import * as GlobalService from "../react/global_services";
import * as GridConfig from "./adjust-customer-charges-grid-bm-configuration";
import * as AdjustCustomerCharges from "../adjustCustomerCharges/adjust-customer-charges.services";
import "./adjustCustomerCharges.scss";
import * as adjustCustomerChargesServices from "./adjust-customer-charges.services-bm";
import PredefinedRateSearch from "./adjust-customer-charges-predefindrate-search-bm";

import axios from "axios";
declare var window: any;
const { $ } = window;
interface Props {
    wmsSelector: string;
    windowId: string;
    sharedFilterObject: any;
    setSharedFilterObject: (filterObject: any) => void;
    selectedRow: any;
    setSelectedRow: (row: any) => void;
    setSelectedRowCount: (count: number) => void;
    isSearchClicked: boolean;
    setIsSearchClicked: (isSearchClicked: boolean) => void;
    step: number;
    optionsFacility: any[];
    chargeCategoryOptions: any[];
}

const gridId = "AdjustCustomerCharges";

const defaultCustomerAdjustmentChargesData = {
    CustomerIdentifier: { Id: 0 },
    FacilityIdentifier: { Id: 0 },
    Notes: "",
    Billing: [],
};

const AdjustCustomerChargesGrid: React.FC<Props> = (props: Props): any => {
    const defaultColumns = GridConfig.getAdjustCustomerChargeColumns().columns;
    const gridDomSelector = props.windowId ? "." + props.windowId + " #" + gridId : "#" + gridId;
    const [recordsCount, setRecordsCount] = useState(0);
    const [gridData, setGridData] = useState([]);
    const [originalGridData, setOriginalGridData] = useState([]);
    const allColumnList = GridConfig.getAdjustCustomerChargeAllColumnList();
    const [schema] = useState(GridConfig.getAdjustCustomerChargeSchema());
    const [isAllDataLoad, setIsAllDataLoad] = useState(false);
    const [isNewColumnAdded, setIsNewColumnAdded] = useState(false);
    const [gridPageSize] = useState(GlobalService.constants.virtualGridDataLimit);

    const applyRateNameFilter = (itemValue: string, filterValue: string, filterType: string): boolean => {
        const itemText = (itemValue || "").toLowerCase().trim();
        const searchText = filterValue.toLowerCase().trim();

        switch (filterType) {
            case "0":
                return itemText.includes(searchText);
            case "1":
                return !itemText.includes(searchText);
            case "2":
                return itemText === searchText;
            case "3":
                return itemText !== searchText;
            case "4":
                return itemText.startsWith(searchText);
            case "5":
                return itemText.endsWith(searchText);
            default:
                return true;
        }
    };

    useEffect(() => {
        if (props.isSearchClicked && originalGridData.length > 0) {
            let rateNameMatches = true;
            let categoryMatches = true;

            const filteredData = originalGridData.filter((item) => {
                if (props.sharedFilterObject.RateName && props.sharedFilterObject.RateName.trim() !== "") {
                    const filterType = props.sharedFilterObject.IndexOptionsRateName ?? 0; // Default to "Contains" if not specified
                    rateNameMatches = applyRateNameFilter(
                        item.ChargeLabel || "",
                        props.sharedFilterObject.RateName,
                        filterType.toString()
                    );
                }

                if (props.sharedFilterObject.category && props.sharedFilterObject.category.trim() !== "") {
                    const categoryFilter = props.sharedFilterObject.category.toLowerCase().trim();
                    const itemCategory = item.Category?.toLowerCase() || "";
                    categoryMatches = itemCategory === categoryFilter;
                }

                const shouldInclude = rateNameMatches && categoryMatches;
                return shouldInclude;
            });

            setRecordsCount(filteredData.length);
            setGridData(filteredData);
            props.setIsSearchClicked(false);
        }
    }, [props.isSearchClicked, props.sharedFilterObject, originalGridData]);

    const onselectGridRow = (KendoGrid: any) => {
        let grid = $(gridDomSelector).data("kendoGrid");
        var data = grid.dataItem(grid.select());
        if (data) {
            props.setSelectedRow(data);
            props.setSelectedRowCount(KendoGrid.getNumberOfSelections());
        } else {
            props.setSelectedRow(defaultCustomerAdjustmentChargesData);
            props.setSelectedRowCount(0);
        }
    };

    const listGrid_dataBind = (allData) => {
        let count = 1;
        for (let i = 0; i < allData.length; i++) {
            allData[i].RowNumber = count++;
            allData[i].BillTotalCharges = 0;
            if (allData[i].Billing) {
                for (let j = 0; j < allData[i].Billing.length; j++) {
                    const ChargeBill = allData[i].Billing[j];
                    allData[i].BillTotalCharges = allData[i].BillTotalCharges + ChargeBill.TotalCharges;
                }
            }
        }
        setGridData(allData);
        setOriginalGridData(allData);
    };

    useEffect(() => {
        callForGetNewData();
    }, []);

    const callForGetNewData = () => {
        loadAllRecords();
    };
    const getAllResponseData = (data) => {
        setRecordsCount(data.length);
        // Restructure data to match column order for proper copy functionality
        const restructuredData = data.map((item) => {
            return {
                Name: item.Name || item.ChargeLabel,
                ChargeLabel: item.ChargeLabel,
                Description: item.Description || item.ChargeLabel,
                TransactionType: item.TransactionType,
                Category: item.Category,
                WarehouseName: item.WarehouseName,
                ChargePerUnit: item.Detail?.ChargePerUnit,
                TotalCharges: item.TotalCharges,
                ...item,
            };
        });

        let allData = [];
        allData = [...restructuredData, ...allData];
        listGrid_dataBind(allData);
        setIsAllDataLoad(true);
        setIsNewColumnAdded(false);
    };
    const loadAllRecords = () => {
        const facilityId = props.sharedFilterObject.FacilityID.toString();
        const customerId = props.sharedFilterObject.CustomerID.toString();
        adjustCustomerChargesServices.getPredefinedManualRates(customerId, facilityId).then((response) => {
            if (response.data) {
                response.data = response.data.map((item, index) => {
                    item.rowId = index;
                    return item;
                });
                let charges = response.data;
                getAllResponseData(charges);
            }
        });
    };

    return (
        <>
            {props.step === 2 && props.sharedFilterObject.ChargeType === "isPredefinedRate" && (
                <PredefinedRateSearch
                    wmsSelector={props.wmsSelector}
                    filterObject={props.sharedFilterObject}
                    optionsFacility={props.optionsFacility}
                    setIsSearchClicked={props.setIsSearchClicked}
                    chargeCategoryOptions={props.chargeCategoryOptions}
                    setSharedFilterObject={props.setSharedFilterObject}
                />
            )}
            <div className="adjust-customer-charges-grid">
                <VirtualGridComponent
                    virtualGridDataLimit={gridPageSize}
                    isNewColumnAdded={isNewColumnAdded}
                    callForGetNewData={callForGetNewData}
                    isAllDataLoad={isAllDataLoad}
                    loadAllMessageFirst={window.translate("Label_Grid_Filter_Message")}
                    loadAllMessageSecond={window.translate("Label_Grid_Filter_Message_2")}
                    shawCheckbox={false}
                    showResetButton={false}
                    id={gridId}
                    showSortColumns={true}
                    showGridSummary={true}
                    gridName={"AttachFileToAssembly"}
                    windowId={props.windowId}
                    wmsSelector={"AttachFileToAssembly"}
                    gridKeySelection={"RowNumber"}
                    virtual={true}
                    totalResult={recordsCount}
                    staticGridData={gridData}
                    exportable={true}
                    allColumns={allColumnList}
                    defaultColumns={defaultColumns}
                    schema={schema}
                    onSelection={onselectGridRow}
                    metaDataFieldsName={"ManageAttachFileAssembly"}
                    filterText={""}
                    fullFilterText={""}
                    emptyRecoredText={window.translate("Window_Title_Label_Empty_Records")}
                    isExportSelectedData={true}
                    exportExcelObj={{
                        fileName:
                            "AdjustCustomerChargesExport-" +
                            kendo.toString(kendo.parseDate(new Date().toString()), "yyyyMMddhhmmss") +
                            ".xlsx",
                        allPages: true,
                        filterable: true,
                    }}
                    csvExportFileName={"AdjustCustomerChargesExport"}
                    menu={[
                        {
                            name: "Copy",
                            value: [
                                {
                                    name: window.translate("Label_Copy_Field"),
                                    value: [],
                                    disabled: false,
                                    disabledText: window.translate("Label_Copy_Field"),
                                    icon: "fa-bandcamp",
                                    color: "green",
                                    isContextMenu: true,
                                    isButtonMenu: false,
                                    wmsid: "copyField",
                                    wmsSelector: "copyToClicpboard",
                                },
                                {
                                    name: window.translate("Label_Copy_Row"),
                                    value: [],
                                    disabled: false,
                                    disabledText: window.translate("Label_Copy_Row"),
                                    icon: "fa-wrench",
                                    color: "green",
                                    isContextMenu: true,
                                    isButtonMenu: false,
                                    wmsid: "copyRow",
                                },
                            ],
                            disabled: false,
                            disabledText: "You may not add blahssss0",
                            icon: "fa-wrench",
                            color: "green",
                            isContextMenu: true,
                            isButtonMenu: false,
                        },
                    ]}
                />
            </div>
        </>
    );
};
AdjustCustomerChargesGrid.propTypes = {};

export default React.memo(AdjustCustomerChargesGrid);
